import React from "react";
import './index.scss';
import { BackTop } from 'antd';
import {UpOutlined} from '@ant-design/icons';


const BackToTop = () => {

    return (<>
        <BackTop className='back-to-top'>
            <div className='back-to-top-content'>
                <UpOutlined />
            </div>
        </BackTop>
    </>
    )
}

export default BackToTop;
